export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14124.3d0611ba.jpg";